import { Card } from '@quno/patient-journey/src/components/Card/Card';

export type CodeProps = {
  embed: string;
};

export const CodeCard = ({ embed }: CodeProps): JSX.Element => {
  return (
    <Card style={{ border: 'none' }}>
      <div dangerouslySetInnerHTML={{ __html: embed }} />
    </Card>
  );
};
